import React from 'react';
import ReactDOM from 'react-dom';

import SimpleGallery from 'components/simplegallery/simplegallery'
import Bid from 'components/bid/bid'
import CountDownTimer from "components/marketplace/countDownTimer"



class Vehicle extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row vehicle-component">
        <div className="col-md-7">
          <SimpleGallery image_urls={this.props.vehicle.vehicle_photos} />
        </div>
        <div className="col-md-5">
          <CountDownTimer endDate={gon.vehicle.end_time} expired={!gon.bid.active_sale} />
          <Bid marketplace_id={this.props.vehicle.id} bid={{...this.props.bid}}/>
          <div className="overview-component">
            <h5>Overview</h5>
            <br/>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-12">
                <p>
                  <img src="https://etender.graysonline.com/assets/icons/speedometer-95728f43aea02149e5cc5bc37936344efa9ba3ad7c3393d4f41d8a5ed20e86b1.png"/>
                  {this.props.vehicle.mileage} km indicated
                </p>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-12">
                <p>
                  <img src="https://etender.graysonline.com/assets/icons/body-aaa6e3bf4cdc4727eb369145c1a5b90ed49323a14795ecb97b71fd04300bdba2.png"/>
                  {this.props.vehicle.body_type}
                </p>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-12">
                <p>
                  <img src="https://etender.graysonline.com/assets/icons/engine-ba349e76e17154b7610b45e20e493cb2af4aff5634cb0bdea399f54664f9d655.png"/>
                  {this.props.vehicle.engine_capacity} {this.props.vehicle.fuel}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Vehicle;
